import { PropTypes } from 'prop-types';
import css from './Loading.module.css';
import Iconify from '../../Iconify';
import useLocales from '../../../hooks/useLocales';

Downloading.propTypes = {
  sx: PropTypes.any,
};

export default function Downloading({ sx }) {
  const { translate } = useLocales();
  return (
    <div className={css.loading} style={sx}>
      <div className={css.text2}>
        <Iconify icon="eos-icons:bubble-loading" color="#ffc425" width={44} height={44} />
        <div>{translate('objects.downloading')}</div>
      </div>
    </div>
  );
}
